import React from "react";
import "./Marquee.css";

const Marquee = ({ children, speed = 20 }) => {
  return (
    <div className="marquee ">
      <div className="marquee-track" style={{ animationDuration: `${speed}s` }}>
        <div className="marquee-content">{children}</div>
        <div className="marquee-content">{children}</div>
      </div>
    </div>
  );
};

export default Marquee;
